import { useState, useEffect } from 'react';
import { CircleNotch, ArrowsClockwise, PaperPlaneRight, Warning } from '@phosphor-icons/react';
import { API } from './constants';

export function GraphStatusBanner() {
  const [status, setStatus] = useState(null);
  const [syncing, setSyncing] = useState(false);
  const [sendingTest, setSendingTest] = useState(false);
  const [testResult, setTestResult] = useState(null);

  useEffect(() => {
    fetch(`${API}/graph/status`, { credentials: 'include' })
      .then(r => r.json()).then(setStatus).catch(() => {});
  }, []);

  const syncInbox = async () => {
    setSyncing(true);
    try {
      const res = await fetch(`${API}/graph/inbox/sync`, { method: 'POST', credentials: 'include', headers: { 'Content-Type': 'application/json' } });
      const data = await res.json();
      setTestResult(`${data.synced || 0} nieuwe emails gesynchroniseerd`);
    } catch { setTestResult('Sync mislukt'); }
    setSyncing(false);
  };

  const sendTest = async () => {
    setSendingTest(true); setTestResult(null);
    try {
      const res = await fetch(`${API}/graph/send-test`, {
        method: 'POST', credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ to_email: status?.email || 'info@poolfix.nl' }),
      });
      const data = await res.json();
      setTestResult(data.status === 'sent' ? 'Test email verzonden!' : `Fout: ${data.error || 'Onbekend'}`);
    } catch { setTestResult('Verzending mislukt'); }
    setSendingTest(false);
  };

  if (!status) return null;

  if (status.connected) {
    return (
      <div className="mt-6 p-4 bg-emerald-50 border border-emerald-200 rounded-sm" data-testid="graph-status-banner">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2 text-sm text-emerald-800">
            <span className="w-2 h-2 rounded-full bg-emerald-500 animate-pulse" />
            <strong>Microsoft Graph API — Live</strong>
            <span className="text-emerald-600">|</span>
            <span>{status.email}</span>
            <span className="text-emerald-600">|</span>
            <span>{status.inbox_total} emails, {status.inbox_unread} ongelezen</span>
          </div>
          <div className="flex gap-2">
            <button onClick={syncInbox} disabled={syncing} data-testid="sync-inbox-btn"
              className="flex items-center gap-1.5 px-3 py-1.5 text-xs font-medium bg-emerald-600 text-white rounded-sm hover:bg-emerald-700 disabled:opacity-50 transition-colors">
              {syncing ? <CircleNotch size={12} className="animate-spin" /> : <ArrowsClockwise size={12} />}
              {syncing ? 'Syncing...' : 'Sync Inbox'}
            </button>
            <button onClick={sendTest} disabled={sendingTest}
              className="flex items-center gap-1.5 px-3 py-1.5 text-xs font-medium bg-white text-emerald-700 border border-emerald-300 rounded-sm hover:bg-emerald-50 disabled:opacity-50 transition-colors">
              {sendingTest ? <CircleNotch size={12} className="animate-spin" /> : <PaperPlaneRight size={12} />}
              Test Email
            </button>
          </div>
        </div>
        {testResult && <div className="mt-2 text-xs text-emerald-700">{testResult}</div>}
      </div>
    );
  }

  return (
    <div className="mt-6 p-3 bg-amber-50 border border-amber-200 text-sm text-amber-800 flex items-center gap-2" data-testid="graph-status-banner">
      <Warning size={16} className="shrink-0" />
      <span><strong>MS Graph: {status.configured ? 'Verbindingsfout' : 'Niet geconfigureerd'}</strong> — {status.error || 'Configureer credentials in .env'}</span>
    </div>
  );
}
